import { useQuery } from '@tanstack/react-query';
import { getCategories } from '../services/categoryService';

export function useCategories(department?: string) {
  return useQuery({
    queryKey: ['categories', department ?? null],
    queryFn: () => getCategories(department),
  });
}
